import appsetting from "../public/appSettings.json";
import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });
import jalaali from "jalaali-js";
const URLAPI = appsetting.ApiUrl;
// const pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
// const en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

export const ReadArrayFromCookies = (baseName = "menuData") => {
  const result = [];
  let index = 0;

  while (true) {
    const cookieName = `${baseName}_${index}`;
    const value = Cookies.get(cookieName);
    if (!value) break;

    try {
      const parsed = JSON.parse(value);
      result.push(...parsed);
    } catch (e) {
      console.error(`خطا در خواندن کوکی ${cookieName}:`, e);
    }

    index++;
  }

  return result;
};
export const ReadArrayMenuAsLocalStorage = (baseName = "menuData") => {
  const data = localStorage.getItem(baseName);
  return data ? JSON.parse(data) : [];
};
const GlobalPlugin = {
  install(app) {
    app.config.globalProperties.$SetUrl = function (url) {
      URLAPI = url;
    };
    app.config.globalProperties.$CapitalizeKeys = function (obj) {
      const newObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
          newObj[capitalizedKey] = obj[key];
        }
      }
      return newObj;
    };
    app.config.globalProperties.$LowercaseKeys = function (obj) {
      const newObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const lowerKey = key.charAt(0).toLowerCase() + key.slice(1);
          newObj[lowerKey] = obj[key];
        }
      }
      return newObj;
    };
    app.config.globalProperties.$getUser = function () {
      return JSON.parse(this.$GetCookies("user"));
    };
    app.config.globalProperties.$getMenus = function () {
      return JSON.parse(this.$GetCookies("menus"));
    };
    app.config.globalProperties.$PostData = function (method, url, data, fromForm) {
      var axios = require("axios");
      // axios.defaults.withCredentials=true
      var config = {
        method: method,
        url: URLAPI + url,
        headers: {
          Authorization: "Bearer " + this.$GetCookies("token"),
          "Content-Type": "application/json",
        },
      };
      if ((data != null) & (data != undefined)) {
        config.data = JSON.stringify(data);
      }
      if (fromForm == true) {
        config.headers = {
          "Content-Type": "multipart/form-data",
        };
        config.data = data;
      }

      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          console.error("error", error);
        });
    };
    app.config.globalProperties.$PostFormData = function (method, url, data) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      axios.defaults.withCredentials = true;
      var data = data;
      var config = {
        method: method,
        url: URLAPI + url,
        headers: {
          Authorization: "Bearer " + this.$GetCookies("token"),
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };
      return axios(config).then((response) => response.data);
    };
    app.config.globalProperties.capitalize = function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    app.config.globalProperties.$CreateKey = function (data) {
      const secretKey = CryptoJS.enc.Utf8.parse("Omid12345678Omid");
      const plaintext = JSON.stringify(data);
      const encrypted = CryptoJS.AES.encrypt(plaintext, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    };
    app.config.globalProperties.$SweetAlert = function (title, text, icon, timer = 1000) {
      // icon: "success"; // موفقیت ✅
      // icon: "error"; // خطا ❌
      // icon: "warning"; // هشدار ⚠️
      // icon: "info"; // اطلاعات ℹ️
      // icon: "question"; // سوال ❓
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
        position: "center",
        timer: timer,
        showConfirmButton: false,
        showCancelButton: false,
        customClass: {
          popup: "my-swal-rtl",
        },
      });
    };
    app.config.globalProperties.$CloaseSweetAlert = function () {
      Swal.close();
    };
    app.config.globalProperties.$SweetQustion = function (title, text, icon, confirmButtonText, cancelButtonText, node, fun1, fun2) {
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#1fad1f",
        cancelButtonColor: "#ad291f",
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        customClass: {
          popup: "my-swal-rtl",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (node != null) {
            fun1(node);
          } else {
            fun1();
          }
        } else {
          fun2(node);
        }
      });
    };
    app.config.globalProperties.$SweetAlertTost = function (title, text, icon, timer = 1000) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: timer,
        icon: icon,
        title: title,
        text: text,
        timerProgressBar: true,
        customClass: {
          popup: "my-swal-rtl",
        },
      });
    };
    app.config.globalProperties.$SweetGetPrice = async function () {
      const { value: trackingCode } = await Swal.fire({
        title: "کد رهگیری بانکی",
        input: "number",
        inputLabel: "لطفا کد رهگیری واریزی خودرا جهت استعلام وارد نمایید",
        inputPlaceholder: "مثلاً: 1234567890ABC",
        showCancelButton: true,
        inputAttributes: {
          min: 1,
          step: 1,
        },
        customClass: {
          popup: "my-swal-rtl",
        },
        confirmButtonText: "تأیید",
        cancelButtonText: "انصراف",
        inputValidator: (value) => {
          if (!value || value.trim().length < 6) {
            return "لطفاً یک کد رهگیری معتبر وارد کنید (حداقل ۶ کاراکتر)";
          }
        },
      });
      return trackingCode ?? null;
    };
    app.config.globalProperties.$SweetGetDesTakhir = async function () {
      const { value: DesTakhir } = await Swal.fire({
        title: "علت تاخیر",
        input: "text",
        inputLabel: "لطفا علت تاخیر را درصورت اطلاع وارد کنید",
        inputPlaceholder: "",
        icon: "info",
        showCancelButton: true,
        customClass: {
          popup: "my-swal-rtl",
        },
        confirmButtonText: "ثبت",
        cancelButtonText: "انصراف",
      });
      return DesTakhir ?? null;
    };
    app.config.globalProperties.$SweetGetDesGeybat = async function () {
      const { value: DesTakhir } = await Swal.fire({
        title: "علت غیبت",
        input: "text",
        inputLabel: "لطفا علت غیبت را درصورت اطلاع وارد کنید",
        inputPlaceholder: "",
        icon: "info",
        showCancelButton: true,
        customClass: {
          popup: "my-swal-rtl",
        },
        confirmButtonText: "ثبت",
        cancelButtonText: "انصراف",
      });
      return DesTakhir ?? null;
    };
    app.config.globalProperties.$SweetCombo = async function () {
      const { value: status } = await Swal.fire({
        title: "انتخاب وضعیت پرداخت",
        input: "select",
        inputLabel: "وضعیت واریزی کاربر را مشخص کنید",
        inputAttributes: {
          dir: "rtl", // اگر بخوای از چپ به راست باشه
        },
        inputOptions: {
          waiting: "در انتظار بررسی",
          success: "تایید پرداخت",
          failed: "عدم پرداخت",
        },
        customClass: {
          popup: "my-swal-rtl",
        },
        inputPlaceholder: "انتخاب کنید...",
        showCancelButton: true,
        confirmButtonText: "تأیید",
        cancelButtonText: "انصراف",
        inputValidator: (value) => {
          if (!value) {
            return "لطفاً یک گزینه انتخاب کنید";
          }
        },
      });
      return status ?? null; // null اگر کاربر لغو کرد
    };
    app.config.globalProperties.$ValidEngilsh = function (e, length) {
      if (e.target.value.length > length) {
        this.$SweetAlertTost(" محدودیت کارکتر", " حداکثر طول متن" + " (" + length + ") " + " کارکتر می باشد ", "warning", 2000);
        e.target.value = e.target.value.slice(0, length);
      } else {
        const persianRegex = /[\u0600-\u06FF]/;
        let isPersian = persianRegex.test(e.target.value);
        if (isPersian == true) {
          this.$SweetAlertTost("خطا", "فقط حروف لاتین مجاز است", "error", 2000);
          e.target.value = e.target.value.replace(persianRegex, "");
        }
      }
    };
    app.config.globalProperties.$ValidPersian = function (e, length) {
      if (e.target.value.length > length) {
        this.$SweetAlertTost(" محدودیت کارکتر", " حداکثر طول متن" + " (" + length + ") " + " کارکتر می باشد ", "warning", 2000);
        e.target.value = e.target.value.slice(0, length);
      } else {
        const englishRegex = /[a-zA-Z]/;
        if (englishRegex.test(e.target.value)) {
          this.$SweetAlertTost("خطا", "فقط حروف فارسی مجاز است", "error", 2000);
          e.target.value = e.target.value.replace(englishRegex, "");
        }
      }
    };
    app.config.globalProperties.$ValidNumber = function (e, length) {
      if (e.target.value.length > length) {
        this.$SweetAlertTost(" محدودیت کارکتر", " حداکثر طول متن" + " (" + length + ") " + " کارکتر می باشد ", "warning", 2000);
        e.target.value = e.target.value.slice(0, length);
      } else {
        const numberRegex = /[0-9]/;
        if (!/^\d*$/.test(e.target.value)) {
          this.$SweetAlertTost("خطا", "فقط اعداد مجاز است", "error", 2000);
          e.target.value = e.target.value.replace(/[^0-9]/g, "");
        }
      }
    };
    app.config.globalProperties.$ValidPassword = function (e, data, minLength, Uc, Lc, num) {
      let password = e && e != null ? e.target.value : data;
      const hasLowercase = /[a-z]/.test(password);
      const hasUppercase = /[A-Z]/.test(password);
      const hasNumber = /[0-9]/.test(password);
      if (minLength && minLength != null) {
        if (password.length < minLength) {
          this.$SweetAlertTost(" خطای امنیت", " حداقل طول کـلـمـه عبـور " + " (" + minLength + ") " + " کارکتر می باشد ", "warning", 2000);
          return false;
        }
      }
      if (Uc && Uc != null) {
        if (!hasUppercase) {
          this.$SweetAlertTost("خطای امنیت", "کـلـمـه عبـور باید شامل حداقل یک حرف بزرگ انگلیسی باشد", "error", 3000);
          return false;
        }
      }
      if (Lc && Lc != null) {
        if (!hasLowercase) {
          this.$SweetAlertTost("خطای امنیت", "کـلـمـه عبـور باید شامل حداقل یک حرف کوچک انگلیسی باشد", "error", 3000);
          return false;
        }
      }
      if (num && num != null) {
        if (!hasNumber) {
          this.$SweetAlertTost("خطای امنیت", "کـلـمـه عبـور باید شامل حداقل یک عدد باشد", "error", 3000);
          return false;
        }
      }
      return true;
    };
    app.config.globalProperties.$requiredCodeMeli = function (frm) {
      var currform = document.getElementById(frm);
      var textboxCodeMeli = currform.getElementsByClassName("required-CodeMeli");
      for (let index = 0; index < textboxCodeMeli.length; index++) {
        if (textboxCodeMeli[index].value.trim() == "") {
          // alert("");
          // console.log('Error', textboxCodeMeli[index])
          textboxCodeMeli[index].classList.add("wronginput");
          this.$SweetAlertTost("خطا", "کد ملی باید 10 رقم باشد", "error", 2000);
          return true;
        } else {
          var allDigitEqual = ["0000000000", "1111111111", "2222222222", "3333333333", "4444444444", "5555555555", "6666666666", "7777777777", "8888888888", "9999999999"];
          var txtCodeMeli = [];
          txtCodeMeli = String(textboxCodeMeli[index].value);
          if (allDigitEqual.find((element) => element == txtCodeMeli) > 0) {
            textboxCodeMeli[index].classList.add("wronginput");
            this.$SweetAlertTost("خطا", "کد ملی صحیح نمیباشد ، تمام اعداد یکسان وارد شده است !", "error", 2000);
            return false;
          }
          var chArray = textboxCodeMeli[index].value.split("");
          var num0 = chArray[0] * 10;
          var num2 = chArray[1] * 9;
          var num3 = chArray[2] * 8;
          var num4 = chArray[3] * 7;
          var num5 = chArray[4] * 6;
          var num6 = chArray[5] * 5;
          var num7 = chArray[6] * 4;
          var num8 = chArray[7] * 3;
          var num9 = chArray[8] * 2;
          var a = chArray[9];
          var b = num0 + num2 + num3 + num4 + num5 + num6 + num7 + num8 + num9;
          var c = b % 11;
          var b_ret = (c < 2 && a == c) || (c >= 2 && 11 - c == a);
          if (b_ret == false) {
            textboxCodeMeli[index].classList.add("wronginput");
            this.$SweetAlertTost("خطا", "کد ملی صحیح نمی باشد", "error", 2000);
            return false;
          } else {
            textboxCodeMeli[index].classList.remove("wronginput");
          }
        }
      }
      return true;
    };
    app.config.globalProperties.$required = function (frm) {
      var currform = document.getElementById(frm);
      var textbox = currform.getElementsByClassName("required");
      for (let index = 0; index < textbox.length; index++) {
        if (textbox[index].tagName == "SELECT") {
          if (textbox[index].value != -1) {
            textbox[index].classList.remove("wronginput");
          } else {
            textbox[index].classList.add("wronginput");
            textbox[index].focus();
            // console.log(textbox[index])
            this.$SweetAlertTost("ورودی نا معتبر", "فیلد مشخص شده الزامی می باشد ", "error", 1200);
            return false;
          }
        } else {
          let value = textbox[index].value.replace(/\s/g, "");
          if (!textbox[index].value || value == "") {
            textbox[index].classList.add("wronginput");
            textbox[index].focus();

            this.$SweetAlertTost("ورودی نا معتبر", "فیلد مشخص شده الزامی می باشد ", "error", 1500);
            return false;
          } else {
            textbox[index].classList.remove("wronginput");
          }
        }
      }
      return true;
    };
    app.config.globalProperties.$ValidForm = function (frm) {
      return this.$required(frm) && this.$requiredCodeMeli(frm);
    };
    app.config.globalProperties.$GetJalaliDateTimeUnique = function () {
      const now = moment(); // زمان فعلی
      const date = now.format("jYYYYjMMjDD"); // 140403/19
      const time = now.format("HHmmss"); // 00:26:45
      return date + "" + time;
    };
    app.config.globalProperties.$GetJalaliDateTime = function () {
      const now = moment(); // زمان فعلی
      const date = now.format("jYYYY/jMM/jDD"); // 1404/03/19
      const time = now.format("HH:mm:ss"); // 00:26:45
      return `${date} ${time}`;
    };
    app.config.globalProperties.$GetJalaliDate = function () {
      var Dt = moment().format("jYYYY/jMM/jDD");
      return Dt;
    };
    app.config.globalProperties.$UnixTimeToJalaliDate = function (unixTimestamp) {
      var Dt = moment(unixTimestamp * 1000).format("HH:mm:ss - jYYYY/jMM/jDD");
      return Dt;
    };
    app.config.globalProperties.$Comma3ragham = function (Number) {
      if (Number == 0 || Number == "0") {
        return Number;
      }
      Number += "";
      Number = Number.replace(/,/g, "").replace(/\./g, "");
      var x = Number.split(".");
      var y = x[0];
      var z = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
      return y + z;
    };
    app.config.globalProperties.$PutCommatoInput = function () {
      var mabalegh = document.getElementsByClassName("3ragham");
      mabalegh = Array.prototype.slice.call(mabalegh);
      mabalegh.forEach((element) => {
        while (element.value.charAt(0) === "0" && element.value.length > 1) {
          element.value = element.value.substring(1);
        }
        element.value = element.value.replace(/,/g, "").replace(/\./g, "");
        // element.value = element.value..replace(/\./g,' ')
        element.value = this.$Comma3ragham(element.value);
      });
    };
    app.config.globalProperties.$ParseToNumber = function (priceString) {
      if (!priceString) return 0;

      // حذف همه جداکننده‌ها (کاما انگلیسی و فارسی)
      const clean = priceString.replace(/[٬,]/g, "");

      // تبدیل به عدد
      return Number(clean);
    };

    app.config.globalProperties.$SetCookies = function (key, value, time = 1) {
      Cookies.set(key, value, { expires: time }); // ۷ روزه
    };
    app.config.globalProperties.$GetCookies = function (key) {
      return Cookies.get(key);
    };
    app.config.globalProperties.$RemoveCookies = function (key) {
      Cookies.remove(key);
    };

    app.config.globalProperties.$GetDateArray = function (jalaliDatesArray) {
      // const weekdays = [  "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه","شنبه","یکشنبه",];
      // let DayNumber = 0;

      // return jalaliDatesArray.map((jDate) => {
      //   const [jy, jm, jd] = jDate.split("/").map(Number);
      //   const { gy, gm, gd } = jalaali.toGregorian(jy, jm, jd);

      //   const date = new Date(gy, gm - 1, gd);
      //   const jsDay = date.getDay(); // یکشنبه = 0
      //   const adjustedDay = (jsDay + 6) % 7; // حالا شنبه = 0

      //   const Day = weekdays[adjustedDay];
      //   DayNumber++;

      //   return { Date: jDate, Day, DayNumber, Id: null };
      // });
      const weekdays = {
        0: "یکشنبه",
        1: "دوشنبه",
        2: "سه‌شنبه",
        3: "چهارشنبه",
        4: "پنجشنبه",
        5: "جمعه",
        6: "شنبه",
      };

      let DayNumber = 0;

      return jalaliDatesArray.map((jDate) => {
        const [jy, jm, jd] = jDate.split("/").map(Number);
        const { gy, gm, gd } = jalaali.toGregorian(jy, jm, jd);

        const date = new Date(gy, gm - 1, gd);
        const jsDay = date.getDay(); // 0 to 6

        const Day = weekdays[jsDay]; // دقیق و بی‌اشتباه
        DayNumber++;

        return { Date: jDate, Day, DayNumber, Id: null };
      });
    };

    app.config.globalProperties.$GetJalaliDatesBetween = function (StartDate, EndDate) {
      return new Promise(function (success, failed) {
        const dates = [];
        let current = moment(StartDate, "jYYYY/jMM/jDD");
        const end = moment(EndDate, "jYYYY/jMM/jDD");
        while (current.isSameOrBefore(end)) {
          dates.push(current.format("jYYYY/jMM/jDD"));
          current.add(1, "day");
        }
        success(dates);
      });
    };

    app.config.globalProperties.$CheckAccess = function (KeyMenu) {
      let restoredArray = this.$GetArray();
      let userRole = JSON.parse(this.$GetCookies("user")).tblComboCatIdUserRole;
      if (userRole == 40) {
        return true;
      } else {
        let menu = restoredArray.find((x) => x.routeMenu == KeyMenu);
        if (menu != undefined) {
          return true;
        } else {
          return false;
        }
      }
    };

    app.config.globalProperties.$LocalStorageSize = function (array, baseName = "menuData", chunkSize = 15) {
      const size = new Blob(Object.values(localStorage)).size;
      console.log(size / 1024 / 1024, "MB");
    };
    app.config.globalProperties.$SaveArrayToCookies = function (array, baseName = "menuData", chunkSize = 15) {
      let index = 0;
      while (Cookies.get(`${baseName}_${index}`)) {
        Cookies.remove(`${baseName}_${index}`);
        index++;
      }

      // تقسیم آرایه به تکه‌ها
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }

      // ذخیره هر chunk در کوکی جداگانه
      chunks.forEach((chunk, i) => {
        const cookieName = `${baseName}_${i}`;
        Cookies.set(cookieName, JSON.stringify(chunk), { expires: 1, path: "/" }); // 1 روز عمر
      });
    };
    app.config.globalProperties.$ReadArrayFromCookies = function (baseName = "menuData") {
      const result = [];
      let index = 0;

      while (true) {
        const cookieName = `${baseName}_${index}`;
        const value = Cookies.get(cookieName);
        if (!value) break;

        try {
          const parsed = JSON.parse(value);
          result.push(...parsed);
        } catch (e) {
          console.error(`خطا در خواندن کوکی ${cookieName}:`, e);
        }

        index++;
      }

      return result;
    };
    app.config.globalProperties.$SaveArray = function (array, key = "menuData") {
      localStorage.setItem(key, JSON.stringify(array));
    };
    app.config.globalProperties.$GetArray = function (key = "menuData") {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : [];
    };

    app.config.globalProperties.$StatusHandelerSMSIR = function (code) {
      let arr = [
        { key: 0, Msg: "درخواست شما با خطا مواجه شده‌است." },
        { key: 1, Msg: "عملیات با موفقیت انجام شد." },
        { key: 10, Msg: "کلید وب سرویس نامعتبر است" },
        { key: 11, Msg: "کلید وب سرویس غیرفعال است" },
        { key: 12, Msg: "کلید وب سرویس محدود به آی‌پی‌های تعریف شده می‌باشد." },
        { key: 13, Msg: "حساب کاربری غیرفعال است" },
        { key: 14, Msg: "حساب کاربری در حالت تعلیق قرار دارد" },
        { key: 15, Msg: "به منظور استفاده از وب سرویس پلن خود را ارتقا دهید" },
        { key: 16, Msg: "مقدار ارسالی پارامتر نادرست می‌باشد" },
        { key: 20, Msg: "تعداد درخواست بیشتر از حد مجاز است" },
        { key: 101, Msg: "شماره خط نامعتبر میباشد" },
        { key: 102, Msg: "اعتبار کافی نمیباشد" },
        { key: 103, Msg: "درخواست شما دارای متن (های) خالی است" },
        { key: 104, Msg: "درخواست شما دارای موبایل (های) نادرست است" },
        { key: 105, Msg: "تعداد موبایل ها بیشتر از حد مجاز (100 عدد) میباشد" },
        { key: 106, Msg: "تعداد متن ها بیشتر از حد مجاز (100 عدد) میباشد" },
        { key: 107, Msg: "لیست موبایل ها خالی میباشد" },
        { key: 108, Msg: "لیست متن ها خالی میباشد" },
        { key: 109, Msg: "زمان ارسال نامعتبر میباشد" },
        { key: 110, Msg: "تعداد شماره موبایل ها و تعداد متن ها برابر نیستند" },
        { key: 111, Msg: "با این شناسه ارسالی ثبت نشده است" },
        { key: 112, Msg: "رکوردی برای حذف یافت نشد" },
        { key: 113, Msg: "قالب یافت نشد" },
        { key: 114, Msg: "طول رشته مقدار پارامتر، بیش از حد مجاز (25 کاراکتر) میباشد" },
        { key: 115, Msg: "شماره موبایل(ها) در لیست سیاه سامانه می‌باشند" },
        { key: 116, Msg: "نام یک یا چند پارامتر مقداردهی نشده‌است. لطفا به بخش مستندات ارسال وریفای مراجعه فرمایید" },
        { key: 117, Msg: "متن ارسال شده مورد تایید نمی‌باشد" },
        { key: 118, Msg: "تعداد پیام ها بیشتر از حد مجاز میباشد" },
        { key: 119, Msg: "به منظور استفاده از قالب‌ شخصی سازی شده پلن خود را ارتقا دهید" },
        { key: 123, Msg: "خط ارسال‌کننده نیاز به فعال‌سازی دارد." },
        { key: 124, Msg: "درحال حاضر، فقط امکان ارسال پیامک OTP وجود دارد و قالب شما OTP شناسایی نشده است!" },
      ];
      return arr.find((x) => x.key == code).Msg;
    };
    app.config.globalProperties.$DeliveryHandelerSMSIR = function (code) {
      let arr = [
        { key: 1, Msg: "رسیده" },
        { key: 2, Msg: "نرسیده به گوشی" },
        { key: 3, Msg: "رسیده به مخابرات" },
        { key: 4, Msg: "نرسیده به مخابرات" },
        { key: 5, Msg: "رسیده به اپراتور" },
        { key: 6, Msg: "ناموفق" },
        { key: 7, Msg: "لیست سیاه" },
        { key: 8, Msg: "نامشخص" },
      ];
      return arr.find((x) => x.key == code).Msg;
    };
  },
};

export default GlobalPlugin;
